namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_code_bench, {

		pointerEvents: 'none',

		// position: 'sticky',
		bottom: '-1px',
		zIndex: 2,
		// background: {
		// 	color: $mol_theme.back,
		// },
		flex: {
			shrink: 1,
		},

		Card: {
			padding: $mol_gap.block,
			flex: {
				grow: 1,
			},
			gap: $mol_gap.block,
			// background: {
			// 	color: $mol_theme.card,
			// },
		},

		Run_row: {
			gap: $mol_gap.block,
		},
		Run: {
			pointerEvents: 'auto',
		},
		Create_view_widget: {
			pointerEvents: 'auto',
		},
		Run_icon: {
			width: '1.4rem',
		},
		
		Time: {
			padding: $mol_gap.text,
			opacity: 0.6,
			font: {
				family: 'monospace',
			},
			whiteSpace: 'pre',
		},
		
	} )
	
}
